<template>
  <div class="page-recovery-password text-center pt-2 pr-3 pb-3 pl-3">
    <div class="toolbar text-left mb-4">
      <a href="/" class="btn-back" @click.prevent="$router.push({name: 'Home'})">
        <b-icon icon="chevron-left" class="mr-1"/>
        {{ $t("Back") }}</a>
    </div>

    <div class="mb-5 d-block logo">
      <img src="images/full-logo.png" alt="logo" style="max-width: 100%; width: 300px"/>
    </div>

    <ValidationObserver ref="form" tag="form" class="d-block ml-auto mr-auto" style="width: 400px; max-width: 100%"
                        @submit.prevent="join()">
      <b-form-group>
        <ValidationProvider rules="required" v-slot="{ errors }">
          <label><strong>{{ $t('Enter a TranS ID') }}</strong></label>
          <b-input-group class="input-group-trans">
            <b-form-input v-model="formData.transId" :placeholder="$t('TranS ID / Mobile / Email')"
                          :disabled="loading"/>
            <b-input-group-append>
              <b-input-group-text>
                <img src="images/ico-id.png"/>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
          <div class="validate-error">{{ errors[0] }}</div>
        </ValidationProvider>
      </b-form-group>

      <b-form-group class="mb-1">
        <b-button type="submit" pill size="lg" class="btn-block btn-trans-primary" :disabled="loading">{{
            $t("Join Meeting")
          }}
        </b-button>
      </b-form-group>
    </ValidationObserver>
    <PanelLoading :show="loading" message="Connecting to meeting room..."/>
    <MeetingSchedulePicker ref="meetingSchedulePicker" @select="joinMeetingBySchedule"/>
    <AddJoinRequestModal ref="addJoinRequestModal"/>
  </div>
</template>

<script>
import MeetingSchedulePicker from "../components/MeetingSchedulePicker";
import AddJoinRequestModal from "../components/AddJoinRequestModal";
import meetingService from "../services/meeting_service";
import dialogHelper from "../helpers/dialog_helper";
import appHelper from "../helpers/app_helper";

export default {
  name: "JoinMeeting",
  components: {MeetingSchedulePicker, AddJoinRequestModal},
  data: function () {
    return {
      loading: false,
      schedules: null,
      formData: {
        transId: ""
      }
    }
  },
  beforeCreate() {
    this.setTitle("Join Meeting")
  },
  methods: {
    join: async function () {
      if ((await this.$refs.form.validate()) != true)
        return;

      if (this.loading)
        return;

      this.loading = true;
      const response = await meetingService.initAddJoinRequest(this.formData)
      if (!response) {
        this.loading = false;
        return;
      }

      if (!response.startsWith("OK|")) {
        this.loading = false;
        dialogHelper.alert(response, "error");
        return;
      }

      this.schedules = JSON.parse(response.substr(3));
      if (this.schedules.length > 1) {
        this.loading = false;
        this.$refs.meetingSchedulePicker.open(this.schedules);
      }
      else
        await this.joinMeetingBySchedule(this.schedules[0]);
    },
    joinMeetingBySchedule: async function (schedule) {
      if (schedule == null) {
        this.loading = false;
        dialogHelper.alert("Meeting schedule not found", "error");
        return;
      }

      this.loading = true;
      const response = await meetingService.joinMeeting({
        scheduleId: schedule.ScheduleID,
        transId: this.formData.transId
      });

      this.loading = false;
      if (!response)
        return;

      if (response === "REQUIRED_LOGIN") {
        let result = await dialogHelper.confirm("You need to log in before joining the meeting.", "error");
        if (result)
          await this.$router.push({name: 'LogIn', query: {routeName: "JoinMeeting"}});

        return;
      }

      if (response === "NOT_PARTICIPANT") {
        let result = await dialogHelper.confirm("You are not a participant of this meeting room. Please register as a participant of this meeting room before joining the meeting!");
        if (result) {
          this.$refs.addJoinRequestModal.open(this.formData.transId, this.schedules, schedule);
        }
        return;
      }

      if (!response.startsWith("OK|") && !response.startsWith("NOSTART|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      if (response.startsWith("NOSTART|")) {
        let result = await dialogHelper.confirm(response.substr(8));
        if (result) {
          this.joinMeetingBySchedule(schedule);
        }

        return;
      }

      const data = JSON.parse(response.split('|')[1]);
      let isRunning = await appHelper.isMeetingOpening();
      if (isRunning == null) {
        dialogHelper.alert("Your device is not support virtual meeting.", "warning");
        return;
      }

      if (isRunning) {
        dialogHelper.alert("You are already in another meeting, please leave meeting before enter this meeting.", "warning");
        return;
      }

      const result = await appHelper.openMeeting(data);
      if (result !== 0 && isNaN(result)) {
        dialogHelper.alert(result, "error");
        return;
      }

      await this.$router.push({name: 'Home'});
    }
  }
}
</script>